// extracted by mini-css-extract-plugin
export default {"button":"UploadPhotoButton_button__KYnGs","image":"UploadPhotoButton_image__gi06q"};